import React, { useEffect } from "react";
import { Button, Content, Text, Title, Img } from "./ApproveModal.styles";
import Modal from "./ModalTemplate";
import { useTranslation } from "react-i18next";
import SuccessImg from "../../assets/images/success.png";

const ApproveModal = ({ open, onClose, width, height, text, title }) => {
  const { t } = useTranslation();
  const showSuccess =
    text === "order-has-moved-to-customer-care-team" ||
    text === "order-has-moved-to-logistics-team";

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        onClose();
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  return (
    <Modal
      hideScroll
      isOpen={open}
      width={width}
      height={height}
      fade
      onClose={onClose}
      radius={23}
      padding={0}
    >
      <Content>
        {title && <Title>{t(`${title}`)}</Title>}
        {showSuccess && <Img src={SuccessImg} alt="success-img" />}

        {text && <Text>{t(`${text}`)}</Text>}
        {!showSuccess && title && (
          <Button onClick={() => onClose()}>{t("confirm")}</Button>
        )}
      </Content>
    </Modal>
  );
};

export default ApproveModal;
